module.exports = __webpack_public_path__ + "img/04.8fffe846.jpg";